// Upper values include the chart-only savings cap. JA worksheet savings are unlimited.
export const FINANCE_LIMIT_ITEMS = [
    { label: '住宅費(家賃・ローン)', key: 'house', lower: 18, upperRaw: 24 },
    { label: '電気料金', key: 'electricity', lower: 1, upperRaw: 7 },
    { label: 'ガス料金', key: 'gas', lower: 1, upperRaw: 5 },
    { label: '水道料金', key: 'water', lower: 1, upperRaw: 5 },
    { label: '食費', key: 'food', lower: 10, upperRaw: 35 },
    { label: '被服費', key: 'fashion', lower: 3, upperRaw: 7 },
    { label: '自動車(月々支払い)', key: 'car', lower: 12, upperRaw: 19 },
    { label: '電話料金', key: 'smartphone', lower: 1, upperRaw: 5 },
    { label: '情報通信メディア', key: 'media', lower: 1, upperRaw: 6 },
    { label: '日用品', key: 'daily_necessities', lower: 1, upperRaw: 3 },
    { label: '医療(医薬品・健康診断)', key: 'medical', lower: 2, upperRaw: 8 },
    { label: '貯蓄', key: 'saving', lower: 1, upperRaw: 15 },
    { label: '生命保険', key: 'life_insurance', lower: 1, upperRaw: 7 },
    { label: '外食', key: 'eat_out', lower: 1, upperRaw: 10 },
    { label: '習い事(大人・子ども)', key: 'lesson', lower: 1, upperRaw: 7 },
    { label: '防災用品', key: 'emergency_kit', lower: 1, upperRaw: 3 },
    { label: '旅行・レジャー', key: 'trip', lower: 2, upperRaw: 8 }
]

// JA's adopted medical cap takes precedence over the shared API limit.
export function financeUpperRate(item, target, apiValue) {
    if (target === 'ja' && item.key === 'medical') return 6
    return apiValue
}
